export default __webpack_public_path__ + "static/media/depositWithdrawalIcon5.0dd93fcb.webp";